import { Checkbox, Group, Menu, ThemeIcon } from "@mantine/core";
import { IconEqual } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import type { DraggableProvided, DraggableRubric, DraggableStateSnapshot } from "@hello-pangea/dnd";
import type { ListTableColumnFiltered } from "../../types";

export function getRenderDraggable(
  columns: ListTableColumnFiltered[],
  getToggleColumn?: (name: string) => () => void,
  labelTranslation?: string
) {
  return (
    { draggableProps, dragHandleProps, innerRef }: DraggableProvided,
    _: DraggableStateSnapshot,
    rubric: DraggableRubric
  ) => {
    const column = columns[rubric.source.index];
    const { t } = useTranslation();

    const isLocked = column.id === "make";

    return (
      <Menu.Item
        ref={innerRef}
        leftSection={
          <ThemeIcon variant="transparent" color="secondary.4" {...dragHandleProps}>
            <IconEqual size={18} />
          </ThemeIcon>
        }
        onClick={column.disabled !== true ? getToggleColumn?.(column.id) : undefined}
        py="sm"
        {...draggableProps}
      >
        <Group gap="md">
          <Checkbox checked={column.active} disabled={isLocked ? true : column.disabled} />
          {labelTranslation && labelTranslation !== ""
            ? t(labelTranslation + "." + column.label)
            : column.label || column.id}
        </Group>
      </Menu.Item>
    );
  };
}
